/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CurrentUserResponseDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns the current user profile, settings, and the list of partners they have access to. Authenticates via the artic_token cookie or a Bearer JWT in the Authorization header.
 * @summary Get the authenticated user profile
 */
export type currentUserControllerGetCurrentUserResponse200 = {
  data: CurrentUserResponseDto
  status: 200
}

export type currentUserControllerGetCurrentUserResponse401 = {
  data: void
  status: 401
}

export type currentUserControllerGetCurrentUserResponse404 = {
  data: void
  status: 404
}
    
export type currentUserControllerGetCurrentUserResponseSuccess = (currentUserControllerGetCurrentUserResponse200) & {
  headers: Headers;
};
export type currentUserControllerGetCurrentUserResponseError = (currentUserControllerGetCurrentUserResponse401 | currentUserControllerGetCurrentUserResponse404) & {
  headers: Headers;
};

export type currentUserControllerGetCurrentUserResponse = (currentUserControllerGetCurrentUserResponseSuccess | currentUserControllerGetCurrentUserResponseError)

export const getCurrentUserControllerGetCurrentUserUrl = () => {


  

  return `/current-user`
}

export const currentUserControllerGetCurrentUser = async ( options?: RequestInit): Promise<currentUserControllerGetCurrentUserResponse> => {
  
  return customFetch<currentUserControllerGetCurrentUserResponse>(getCurrentUserControllerGetCurrentUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCurrentUserControllerGetCurrentUserQueryKey = () => {
    return [
    `/current-user`
    ] as const;
    }

    
export const getCurrentUserControllerGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentUserControllerGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>> = ({ signal }) => currentUserControllerGetCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CurrentUserControllerGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>>
export type CurrentUserControllerGetCurrentUserQueryError = void


export function useCurrentUserControllerGetCurrentUser<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCurrentUserControllerGetCurrentUser<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCurrentUserControllerGetCurrentUser<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the authenticated user profile
 */

export function useCurrentUserControllerGetCurrentUser<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCurrentUserControllerGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the authenticated user profile
 */
export const prefetchCurrentUserControllerGetCurrentUserQuery = async <TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getCurrentUserControllerGetCurrentUserQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getCurrentUserControllerGetCurrentUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentUserControllerGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>> = ({ signal }) => currentUserControllerGetCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CurrentUserControllerGetCurrentUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>>
export type CurrentUserControllerGetCurrentUserSuspenseQueryError = void


export function useCurrentUserControllerGetCurrentUserSuspense<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCurrentUserControllerGetCurrentUserSuspense<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCurrentUserControllerGetCurrentUserSuspense<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the authenticated user profile
 */

export function useCurrentUserControllerGetCurrentUserSuspense<TData = Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentUserControllerGetCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCurrentUserControllerGetCurrentUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




